// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConformanceError
 */
export interface ConformanceError {
    /**
     * 
     * @type {string}
     * @memberof ConformanceError
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof ConformanceError
     */
    rule: string;
    /**
     * 
     * @type {string}
     * @memberof ConformanceError
     */
    stage: string;
}

/**
 * Check if a given object implements the ConformanceError interface.
 */
export function instanceOfConformanceError(value: object): value is ConformanceError {
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('rule' in value) || value['rule'] === undefined) return false;
    if (!('stage' in value) || value['stage'] === undefined) return false;
    return true;
}

export function ConformanceErrorFromJSON(json: any): ConformanceError {
    return ConformanceErrorFromJSONTyped(json, false);
}

export function ConformanceErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConformanceError {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
        'rule': json['rule'],
        'stage': json['stage'],
    };
}

export function ConformanceErrorToJSON(json: any): ConformanceError {
    return ConformanceErrorToJSONTyped(json, false);
}

export function ConformanceErrorToJSONTyped(value?: ConformanceError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'rule': value['rule'],
        'stage': value['stage'],
    };
}
